import JSZip from "jszip";
import { toast } from "sonner";

const KEY = "psc_photo_autosave";

export const isPhotoAutoSaveEnabled = () => localStorage.getItem(KEY) !== "off";
export const setPhotoAutoSaveEnabled = (on) => localStorage.setItem(KEY, on ? "on" : "off");

const slug = (s, max = 40) =>
  (s || "").toString().trim().replace(/[^a-zA-Z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, max) || "photo";

const dataUrlToBlob = (dataUrl) => {
  const [head, b64] = dataUrl.split(",");
  const mime = (head.match(/data:(.*?);/) || [])[1] || "image/jpeg";
  const bin = atob(b64);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  return new Blob([bytes], { type: mime });
};

const triggerDownload = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
};

const stamp = () => {
  const d = new Date();
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}_${p(d.getHours())}${p(d.getMinutes())}${p(d.getSeconds())}`;
};

/** Save freshly captured photos straight to the device (Downloads folder). */
export const backupPhotosToDevice = (dataUrls, label) => {
  if (!isPhotoAutoSaveEnabled() || !dataUrls?.length) return;
  try {
    dataUrls.forEach((du, i) => {
      const name = `PoolSpa_${slug(label)}_${stamp()}${dataUrls.length > 1 ? `_${i + 1}` : ""}.jpg`;
      triggerDownload(dataUrlToBlob(du), name);
    });
  } catch { /* best-effort backup — never block the inspection */ }
};

/** Bundle every photo in an inspection into one ZIP and download it. */
export const downloadInspectionPhotosZip = async (inspection, labelFor = () => null) => {
  const items = inspection?.items || {};
  const zip = new JSZip();
  let count = 0;
  Object.entries(items).forEach(([qid, v]) => {
    (v?.photos || []).forEach((du, i) => {
      try {
        const label = slug(labelFor(qid) || qid);
        zip.file(`${label}_${i + 1}.jpg`, dataUrlToBlob(du));
        count += 1;
      } catch { /* skip broken photo */ }
    });
  });
  if (!count) { toast.info("This inspection has no photos yet"); return 0; }
  const address = (items.property_address || {}).answer || inspection.title || "inspection";
  const blob = await zip.generateAsync({ type: "blob" });
  triggerDownload(blob, `PoolSpa_${slug(address, 60)}.zip`);
  toast.success(`${count} photo${count > 1 ? "s" : ""} saved to your device`);
  return count;
};
